/* eslint-disable @typescript-eslint/no-explicit-any */
import { MoreOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Dropdown, Image, Tag } from "antd";
import { PlusIcon, SearchIcon } from "../../../../../atoms/CustomIcons";
import { useState } from "react";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";

export default function ProfileSidebar(props: any) {
  const [SiteRecon, setSiteRecon] = useState(true);

  const siteReconFunc = () => {
    setSiteRecon(!SiteRecon);
    SuccessMessage("Synced successfully");
  };

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      {SiteRecon && (
        <Card
          className="profileSidebar site_recon_box"
          style={{ marginBottom: "8px" }}
          onClick={siteReconFunc}
        >
          <div
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img src="/images/dummy/site_recon_icon.svg" alt="" />
            <h6> New measurements from SiteRecon. </h6>
          </div>
          <Button className="outlined-btn"> Sync </Button>
        </Card>
      )}
      <Card className="profileSidebar">
        <h4>Details</h4>
        <div className="sidebarInfo">
          <div className="infoWrapper">
            <h6 className="miniTitle">Account manager</h6>
            <h6 className="miniDetail">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <Avatar src="/images/dummy/user.png" size={20} />
                David L.
              </div>
            </h6>
          </div>
          <div className="infoWrapper">
            <h6 className="miniTitle">Contract status</h6>
            <Tag className="accepted_tag">Contracted</Tag>
          </div>
        </div>

        <div className="preferredCard">
          <div className="visitTop">
            <h5>Preferred visit time</h5>
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              placement="bottomRight"
              className="actionButton"
            >
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => e.stopPropagation()}
                style={{
                  padding: "6px",
                }}
                className="only_icon btn-sm"
                icon={<MoreOutlined />}
              />
            </Dropdown>
          </div>

          <div className="preferredVisitWrapper">
            <div className="visitIcon">
              <Image
                src="/images/profile/calendar-icon.svg"
                preview={false}
                width={15}
              />
            </div>
            <div className="visitInfo">
              <div className="visitInfoTop">
                {props.data.preferredVisitTime.weekdays.Mo && (
                  <div className="visitLabel">Mo</div>
                )}
                {props.data.preferredVisitTime.weekdays.We && (
                  <div className="visitLabel">We</div>
                )}
                {props.data.preferredVisitTime.weekdays.Fr && (
                  <div className="visitLabel">Fr</div>
                )}
                {props.data.preferredVisitTime.weekdays === "Any time" && (
                  <div className="visitLabel" style={{ width: "100%" }}>
                    Weekdays
                  </div>
                )}
              </div>
              {props.data.preferredVisitTime.weekdays.Mo && (
                <div className="visitInfoTime">
                  {props.data.preferredVisitTime.weekdays.Mo}
                </div>
              )}
              {props.data.preferredVisitTime.weekdays === "Any time" && (
                <div className="visitInfoTime">Anytime</div>
              )}
            </div>
          </div>

          {props.data.preferredVisitTime.weekend && (
            <div className="preferredVisitWrapper">
              <div className="visitIcon">
                <Image
                  src="/images/profile/calendar-icon.svg"
                  preview={false}
                  width={15}
                />
              </div>
              <div className="visitInfo">
                <div className="visitInfoTop">
                  <div className="visitLabel" style={{ width: "100%" }}>
                    Weekends
                  </div>
                </div>
                <div className="visitInfoTime">2:00 PM - 6:00 PM</div>
              </div>
            </div>
          )}
        </div>

        <div className="noteCard">
          <h5>Note for crew</h5>
          <div className="noteInfo">{props.data.notes}</div>
        </div>
      </Card>

      <Card
        className="profileSidebar"
        onClick={() =>
          window.open(
            "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
            "_blank"
          )
        }
        style={{ marginTop: "8px", cursor: "pointer" }}
      >
        <div className="documentHeader">
          <h4>Documents</h4>

          <Button className="btn-sm" icon={<PlusIcon />} />
          <Button className="btn-sm" icon={<SearchIcon />} />
        </div>

        <div className="documentListWrapper">
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>{props.data.documents[0]}</span>
            </div>
            <div className="documentImage">
              <Image
                src="/images/dummy/document.png"
                preview={false}
                width={"100%"}
              />
            </div>
          </Card>
          <Card className="documentList">
            <div className="documentItem">
              <Image
                src="/images/profile/icon-folder.svg"
                preview={false}
                width={16}
              />
              <span>{props.data.documents[1]}</span>
            </div>
            <Image src="/images/dummy/document.png" preview={false} />
          </Card>
        </div>
      </Card>
    </>
  );
}
